import { SupportedLanguage }  from '@/hooks/useTranslations';
import CodeServiceModel       from '@/models/CodeServiceModel';
import doc                    from '@widesk-core/decorators/doc';
import model                  from '@widesk-core/decorators/model';

export type CodeTypePropertyReference = (
	'schedule'
	| 'visual_url'
);

@model.urnResource('code_type_property')
@doc.path('/code_type_properties/{?id}')
export default class CodeTypePropertyModel extends CodeServiceModel {
	private declare _tsFilters: {
		'codeEntertainment': id;
		'codeEntertainment.entertainmentUrn': Urn;
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'sourceUrn': Urn;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.string declare reference: CodeTypePropertyReference;

	public getTitle(language: SupportedLanguage) {
		return this.get(`translations.${language}.title`, '');
	}
}